import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

import AppContent from './components/app-content';
import { AppThemeProvider } from './config/theme/provider';

dayjs.locale('pt-br');

const App = () => (
  <AppThemeProvider>
    <AppContent />
  </AppThemeProvider>
);

export default App;
